import { type IChartedMultiStepTreatment } from './charted-multi-step-treatment';
import { type IChartedTreatment } from './charted-treatment';
import { type ITreatmentFork } from './treatment-fork';

export interface ITreatmentPlanProposal {
  forks: ITreatmentFork[];
  treatments: IChartedTreatment[];
  multiTreatments: IChartedMultiStepTreatment[];
}
